.room {
  --mobile-edge: #171127;
  background: linear-gradient(
    180deg,
    #080e24 0%,
    #11142e 28%,
    #25172d 48%,
    #151020 72%,
    #070814 100%
  );
}

.room .scene > .background {
  -webkit-mask-image: linear-gradient(180deg, #000 0%, #000 89%, transparent 100%);
  mask-image: linear-gradient(180deg, #000 0%, #000 89%, transparent 100%);
}

.scene::before {
  content: '';
  position: absolute;
  z-index: 3;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  background: linear-gradient(
    180deg,
    rgba(18, 25, 62, 0.32) 0%,
    rgba(99, 55, 91, 0.24) 35%,
    rgba(236, 105, 69, 0.18) 52%,
    rgba(120, 52, 56, 0.12) 68%,
    transparent 90%
  );
}

.roomActive .scene::before {
  animation: dawnMiddleWash 8s ease-in-out forwards;
}

.dawnBackground {
  z-index: 2;
  opacity: 0;
  transform: scale(1.012);
  transform-origin: 50% 42%;
  will-change: opacity, transform;
}

.starParticles {
  position: absolute;
  z-index: 4;
  inset: 0 0 auto;
  height: 26%;
  overflow: hidden;
  pointer-events: none;
}

.starParticles i {
  --star-x: -6cqw;
  --star-y: 6cqw;
  --star-delay: 2s;
  --star-duration: 14s;
  position: absolute;
  left: 68%;
  top: 12%;
  display: block;
  width: 6.2cqw;
  height: 0.13cqw;
  opacity: 0;
  background: #b9b5db;
  transform: translate3d(0, 0, 0) rotate(-45deg) scaleX(0);
  transform-origin: left center;
  will-change: transform, opacity;
}

.starParticles i:nth-child(1) {
  left: 68%;
  top: 5%;
  --star-delay: 1.5s;
  --star-duration: 11s;
}
.starParticles i:nth-child(2) {
  left: 55%;
  top: 15%;
  --star-x: -5.5cqw;
  --star-y: 5.5cqw;
  --star-delay: 5.2s;
  --star-duration: 15s;
}
.starParticles i:nth-child(3) {
  left: 43%;
  top: 4%;
  --star-x: -6.5cqw;
  --star-y: 6.5cqw;
  --star-delay: 10.5s;
  --star-duration: 19s;
}
.starParticles i:nth-child(4) {
  left: 70%;
  top: 23%;
  --star-x: -5.8cqw;
  --star-y: 5.8cqw;
  --star-delay: 16s;
  --star-duration: 23s;
}

.roomActive .starParticles i {
  animation: starPass var(--star-duration) linear var(--star-delay) infinite;
}

.roomActive .dawnBackground {
  animation: dawnReveal 8s cubic-bezier(0.22, 0.7, 0.18, 1) forwards;
}

.contactConsole {
  position: absolute;
  z-index: 5;
  left: 50%;
  bottom: 7%;
  width: 52cqw;
  transform: translate(-50%, 2.2cqw);
  filter: drop-shadow(1.2cqw 1.45cqw 0 rgba(10, 5, 8, 0.46));
  image-rendering: pixelated;
  container-type: inline-size;
}

.roomActive .contactConsole {
  animation: contactConsoleEnter 0.72s steps(8, end) 0.18s both;
}

.contactConsole > img {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}

.contactScreen {
  position: absolute;
  border-radius: 10px;
  z-index: 2;
  left: 22%;
  top: 23.4%;
  width: 61.7%;
  height: 39.9%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 2.1cqw 2.5cqw 1.8cqw;
  color: #79dc65;
  background: rgba(1, 10, 5, 0.76);
  text-shadow: 0 0 0.55cqw rgba(114, 239, 93, 0.56);
  box-shadow:
    0 0 1.8cqw rgba(111, 235, 91, 0.25),
    inset 0 0 2.2cqw rgba(111, 235, 91, 0.1);
}

.contactScreen::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  opacity: 0.16;
  pointer-events: none;
  background: repeating-linear-gradient(0deg, transparent 0 3px, #73d95b 4px);
}

.contactScreen > span {
  color: #4d9650;
  font-size: clamp(3px, 0.95cqw, 8px);
  letter-spacing: 0.08em;
}

.contactScreen h2 {
  margin: 1.25cqw 0 0.85cqw;
  color: #c9ffaf;
  font:
    400 clamp(7px, 2.25cqw, 20px) / 1.15 'Press Start 2P',
    monospace;
}

.contactScreen p {
  margin: 0 0 1.25cqw;
  color: #71c662;
  font-size: clamp(4px, 1.08cqw, 9px);
}

.contactScreen nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.65cqw;
}

.contactScreen button,
.contactScreen > a {
  border: 0.18cqw solid #326b36;
  color: #5ba85b;
  background: rgba(2, 16, 7, 0.72);
  font: inherit;
  cursor: pointer;
}

.contactScreen button {
  padding: 0.75cqw 0.35cqw;
  font-size: clamp(3px, 0.78cqw, 7px);
}

.contactScreen button:hover,
.contactScreen button:focus-visible,
.contactScreen .contactChannelActive {
  outline: 0;
  border-color: #9cf987;
  color: #d3ffbf;
  background: rgba(37, 100, 40, 0.48);
  box-shadow: 0 0 0.75cqw rgba(115, 217, 91, 0.35);
}

.contactScreen > a {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65cqw;
  min-height: 3.2cqw;
  margin-top: auto;
  text-decoration: none;
  color: #c9ffaf;
  border-color: #6cc961;
  font-size: clamp(3px, 0.85cqw, 8px);
}

.contactScreen > a:hover,
.contactScreen > a:focus-visible {
  outline: 0;
  color: #081108;
  background: #9cf987;
  box-shadow: 0 0 1cqw rgba(115, 217, 91, 0.52);
}

.contactScreen > a svg {
  width: 1.2em;
  height: 1.2em;
}

.transmitHotspot {
  position: absolute;
  z-index: 3;
  left: 81.5%;
  top: 73.8%;
  width: 7.3%;
  height: 13.2%;
  border-radius: 8%;
}

.transmitHotspot:hover,
.transmitHotspot:focus-visible {
  outline: 0.22cqw solid #ff705d;
  outline-offset: 0.2cqw;
  box-shadow: 0 0 1.2cqw rgba(255, 90, 67, 0.72);
}

@keyframes dawnReveal {
  0%,
  8% {
    opacity: 0;
    transform: scale(1.012);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes dawnMiddleWash {
  0%,
  5% {
    opacity: 0;
  }
  38% {
    opacity: 0.82;
  }
  72% {
    opacity: 0.28;
  }
  100% {
    opacity: 0;
  }
}
@keyframes starPass {
  0% {
    opacity: 0;
    transform: translate3d(0, 0, 0) rotate(-45deg) scaleX(0);
  }
  1% {
    opacity: 0.28;
    transform: translate3d(-0.35cqw, 0.35cqw, 0) rotate(-45deg) scaleX(0.06);
  }
  2% {
    opacity: 0.48;
    transform: translate3d(-1.1cqw, 1.1cqw, 0) rotate(-45deg) scaleX(0.2);
  }
  3% {
    opacity: 0.68;
    transform: translate3d(-2cqw, 2cqw, 0) rotate(-45deg) scaleX(0.46);
  }
  4% {
    opacity: 0.72;
    transform: translate3d(-3cqw, 3cqw, 0) rotate(-45deg) scaleX(0.78);
  }
  5% {
    opacity: 0.68;
    transform: translate3d(-4cqw, 4cqw, 0) rotate(-45deg) scaleX(1);
  }
  6% {
    opacity: 0.5;
    transform: translate3d(-4.8cqw, 4.8cqw, 0) rotate(-45deg) scaleX(0.7);
  }
  7% {
    opacity: 0.24;
    transform: translate3d(-5.5cqw, 5.5cqw, 0) rotate(-45deg) scaleX(0.34);
  }
  8% {
    opacity: 0;
    transform: translate3d(var(--star-x), var(--star-y), 0) rotate(-45deg) scaleX(0.05);
  }
  8.01%,
  100% {
    opacity: 0;
    transform: translate3d(var(--star-x), var(--star-y), 0) rotate(-45deg) scaleX(0);
  }
}
@keyframes contactConsoleEnter {
  from {
    opacity: 0;
    transform: translate(-50%, 3.8cqw);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 680px) {
  .contactConsole {
    bottom: 8%;
    width: 92cqw;
  }
  .starParticles i {
    width: 8cqw;
    height: 0.24cqw;
  }
  .contactScreen {
    padding: 2.2cqw 2.6cqw 1.9cqw;
  }
  .contactScreen > span {
    font-size: clamp(3px, 1.3cqw, 5px);
  }
  .contactScreen h2 {
    margin-block: 1.15cqw 0.8cqw;
    font-size: clamp(6px, 2.3cqw, 9px);
  }
  .contactScreen p {
    margin-bottom: 1.1cqw;
    font-size: clamp(3px, 1.4cqw, 6px);
  }
  .contactScreen button {
    padding: 0.8cqw 0.25cqw;
    font-size: clamp(3px, 1.05cqw, 5px);
  }
  .contactScreen > a {
    min-height: 4.2cqw;
    font-size: clamp(3px, 1.18cqw, 5px);
  }
}

@media (max-width: 680px) and (max-height: 760px) {
  .contactConsole {
    bottom: 16%;
    width: 88cqw;
  }
}

@media (min-width: 681px) and (min-aspect-ratio: 3 / 2) {
  .room .scene > .background {
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent 0%,
      #000 12%,
      #000 88%,
      transparent 100%
    );
    mask-image: linear-gradient(90deg, transparent 0%, #000 12%, #000 88%, transparent 100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dawnBackground,
  .contactConsole,
  .scene::before,
  .starParticles i {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}
